import React, { FC, useMemo } from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { GuideLinkExtensionRenderOptions } from '../plugins/GuideLink';
import { LibraryBooks } from '@mui/icons-material';
import { useGuideCmsContext } from '../../../GuideCmsContext';

const renderText = (node: ProseMirrorNode) => {
  return node.attrs.docName;
};

export const GuideLinkView: FC<NodeViewProps> = (props) => {
  const { getGuideTitle } = useGuideCmsContext();
  const title = useMemo(() => getGuideTitle(props.node.attrs.guideId), [props.node.attrs.guideId, getGuideTitle]);
  return (
    <NodeViewWrapper className="react-component" as={'span'}>
      <span className="link link-guide" title={title ?? 'Lenke til anvisning'}>
        <span className="link-icon">
          <LibraryBooks />
        </span>{' '}
        {props.node.attrs.docName}
      </span>
    </NodeViewWrapper>
  );
};

export const getGuideLinkExtensionRenderOptions = (): GuideLinkExtensionRenderOptions => {
  return {
    viewComponent: GuideLinkView,
    renderText: (node) => renderText(node),
  };
};
